import React from 'react';
import moment from 'moment';

var DateBanner = function DateBanner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "date-divider"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("span", null, moment(props.date).format('MMMM Do, YYYY')), /*#__PURE__*/React.createElement("hr", null));
};

export { DateBanner };